import type { CaptureModulePack } from './types';
import { GCamDefaultModule } from './gcam-default-v1';

export const captureModuleRegistry: Record<string, CaptureModulePack> = {
  [GCamDefaultModule.id]: GCamDefaultModule,
};

export function getCaptureModule(id: string): CaptureModulePack {
  return captureModuleRegistry[id] ?? GCamDefaultModule;
}
